/* eslint-disable */
import React, { useEffect, useState } from 'react';
import SvgBottle from '../../../assets/static/img/bottle.svg';
import SvgPhone from '../../../assets/static/img/phone.svg';
import SvgLetter from '../../../assets/static/img/letter.svg';
import SvgWorld from '../../../assets/static/img/world.svg';
import SvgFacebook from '../../../assets/static/img/facebook.svg';
import SvgInstagram from '../../../assets/static/img/instagram.svg';
import SvgLinkedin from '../../../assets/static/img/linkedin.svg';
import SvgTwitter from '../../../assets/static/img/twitter.svg';
import SvgPin from '../../../assets/static/img/pin.svg';
import styles from './ProductDetail.module.scss';
import { A, T, O, M } from 'TOMA';
import Carousel from '../../../components/Carousel/Carousel';
import { ExhibitorRepository } from 'services/Exhibitor/Exhibitor.repository';
import { ProductRepository } from 'services/Product/Product.repository';
import { CodificationRepository } from 'services/Codification/Codification.repository';
import { EventRepository } from 'services/Event/Event.repository';
import { Link, useParams } from 'react-router-dom';
import s from '../../../components/Header/Header.module.scss';
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb';

interface Codification {
  code: string;
  topic: string;
  topicCode: string;
  label: string;
  filter: string;
}

interface ProductRest {
  id: number;
  name: string;
  exhibitorId: string;
  photo_uuid: string;
  photo_extension: string;
  type_produit: string;
  type_vin: string;
  couleur: string;
  region: string;
  classification: string;
  appellation: string;
  type_culture: string;
  millesime: string;
  cepage: string;
  format: string;
  price: string;
  alcool: string;
  type_vendange: string;
  allergene: string;
  arome: string;
  description_fr: string;
  description_en: string;
}
interface Product {
  id: number;
  name: string;
  exhibitorId: string;
  photo: { url: string; width: number; height: number } | null;

  type_produit: string;
  type_vin: string;
  couleur: string;
  region: string;
  classification: string;
  appellation: string;
  type_culture: string;
  millesime: string;
  cepage: string;
  format: string;
  price: string;
  alcool: string;
  type_vendange: string;
  allergene: string;
  arome: string;
  description_fr: string;
  description_en: string;
}

interface ExhibitorRest {
  id: number;
  nom_societe: string;
  contact_revendeur_tel: string;
  email_societe: string;
  site_web: string;
  twitter: string;
  instagram: string;
  linkedin: string;
  facebook: string;
  logo_uuid: string;
  logo_extension: string;
  hall: string;
  stand: string;
}

interface Exhibitor {
  id: number;
  logo: any;
  nom_societe: string;
  contact_revendeur_tel: string;
  email_societe: string;
  site_web: string;
  twitter: string;
  instagram: string;
  linkedin: string;
  facebook: string;
  hall: string;
  stand: string;
}

interface Data {
  error?: any;
  product: Product | null;
  exhibitor: Exhibitor | null;
  otherProduct:
    | {
        id: number;
        name: string;
        photo: { url: string; width: number; height: number } | null;
      }[]
    | null;
}

function getCodif(
  codifications: Codification[],
  topicCode: string,
  multiple?: boolean
): string {
  if (!codifications) return '';

  if (multiple) {
    const codifs = topicCode?.split(';');
    return codifs
      ?.map((tc) => codifications.find((e) => e.topicCode === tc)?.label)
      .join(', ');
  }

  return codifications.find((e) => e.topicCode === topicCode)?.label || '';
}

export default function ProductDetail({}) {
  const [codifications, setCodifications] = useState<Codification[] | []>([]);
  const [otherProduct, setOtherProduct] = useState<Product[] | []>([]);
  const [product, setProduct] = useState<Product | null>(null);
  const [exhibitor, setExhibitor] = useState<Exhibitor | null>(null);
  const [event, setEvent] = useState<any>(null);

  const { slug, product: productSlug } = useParams();

  const codificationRepo = new CodificationRepository();
  const productRepo = new ProductRepository();
  const exhibitorRepo = new ExhibitorRepository();
  const eventRepo = new EventRepository();

  useEffect(() => {
    codificationRepo.search().then((codifications: Codification[]) => {
      setCodifications(codifications);
    });

    eventRepo.getPublicEventBySlug(slug ?? '').then((data) => {
      const eventData = Array.isArray(data) ? data[0] : data;
      setEvent({
        ...eventData,
        logo:
          eventData.company_logo_uuid && process.env.REACT_APP_API_URL
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${eventData.company_logo_uuid}.${eventData.company_logo_extension}`
            : null,
      });
    });
  }, []);

  useEffect(() => {
    productRepo
      .findById(slug ?? '', productSlug ?? '')
      .then(async (productRest: ProductRest) => {
        const sizes = productRest.photo_uuid
          ? await (async () => {
              try {
                return await fetch(
                  `${process.env.REACT_APP_API_URL}/storage/uploads/640/${productRest.photo_uuid}.${productRest.photo_extension}`
                );
              } catch {
                return null;
              }
            })()
          : null;

        const product: any = {
          ...productRest,
          id: productRest.id,
          name: productRest.name,
          exhibitorId: productRest.exhibitorId,
          photo: {
            url: `${process.env.REACT_APP_API_URL}/storage/uploads/640/${productRest.photo_uuid}.${productRest.photo_extension}`,
            width: 640,
            height: 480,
          },
          type_produit: getCodif(codifications, productRest.type_produit),
          type_vin: getCodif(codifications, productRest.type_vin),
          couleur: getCodif(codifications, productRest.couleur),
          region: getCodif(codifications, productRest.region),
          classification: getCodif(codifications, productRest.classification),
          appellation: getCodif(codifications, productRest.appellation),
          type_culture: getCodif(codifications, productRest.type_culture),
          millesime: getCodif(codifications, productRest.millesime),
          cepage: getCodif(codifications, productRest.cepage, true),
          format: getCodif(codifications, productRest.format),
          price: getCodif(codifications, productRest.price),
          alcool: getCodif(codifications, productRest.alcool),
          type_vendange: productRest.type_vendange,
          allergene: productRest.allergene,
          arome: productRest.arome,
          description_fr: productRest.description_fr,
          description_en: productRest.description_en,
        };
        setProduct(product);
      });
  }, [codifications, productSlug]);

  useEffect(() => {
    if (!product) return;
    exhibitorRepo
      .findEventExhibitorById(slug ?? '', product?.exhibitorId ?? '')
      .then(async (data: any) => {
        const sizesLogo = data.logo_uuid
          ? await (async () => {
              try {
                return await fetch(
                  `${process.env.REACT_APP_API_URL}/storage/uploads/640/${data.logo_uuid}.${data.logo_extension}`
                );
              } catch {
                return null;
              }
            })()
          : null;

        setExhibitor({
          id: data.id,
          logo: sizesLogo,
          nom_societe: data.nom_societe,
          contact_revendeur_tel: data.contact_revendeur_tel,
          email_societe: data.email_societe,
          site_web: data.site_web,
          twitter: data.twitter,
          instagram: data.instagram,
          linkedin: data.linkedin,
          facebook: data.facebook,
          hall: data.hall,
          stand: data.stand,
        });
      });

    exhibitorRepo
      .products(slug ?? '', product?.exhibitorId ?? '')
      .then((data: any) => {
        const products = data.map((product: ProductRest) => {
          const photo = product.photo_uuid
            ? {
                url: `${process.env.REACT_APP_API_URL}/storage/uploads/640/${product.photo_uuid}.${product.photo_extension}`,
                width: 640,
                height: 480,
              }
            : null;
          return {
            id: product.id,
            name: product.name,
            photo: photo,
          };
        });
        setOtherProduct(products);
      });
  }, [product?.exhibitorId]);

  const info = [
    { label: 'Type of product', value: product?.type_produit || '' },
    { label: 'Type of wine', value: product?.type_vin || '' },
    { label: 'Color', value: product?.couleur || '' },
    { label: 'Région', value: product?.region || '' },
    { label: 'Classification', value: product?.classification || '' },
    { label: 'Appellation AOC/AOP', value: product?.appellation || '' },
    { label: 'Type of wine-growing', value: product?.type_culture || '' },
    { label: 'Vintage', value: product?.millesime || '' },
    { label: 'Grape variety', value: product?.cepage || '' },
    { label: 'Format', value: product?.format || '' },
    { label: 'Price range', value: product?.price || '' },
    { label: 'Degree of alcohol (%)', value: product?.alcool || '' },
    { label: 'Type of grape picking', value: product?.type_vendange || '' },
    { label: 'Allergens', value: product?.allergene || '' },
    { label: 'Flavors', value: product?.arome || '' },
  ];

  const contact = [
    {
      icon: <img src={SvgBottle} alt="" />,
      label: exhibitor?.nom_societe,
    },
    {
      icon: <img src={SvgPhone} alt="" />,
      label: exhibitor?.contact_revendeur_tel,
    },
    {
      icon: <img src={SvgLetter} alt="" />,
      label: exhibitor?.email_societe,
    },
    {
      icon: <img src={SvgWorld} alt="" />,
      label: exhibitor?.site_web,
    },
  ];

  const length = (otherProduct?.length ?? 0) - 1;
  const foundIndex = otherProduct.findIndex((p) => p.id === product?.id);
  const currentIndex = foundIndex < 0 ? 0 : foundIndex;
  const prevIndex = currentIndex < 1 ? length : currentIndex - 1;
  const nextIndex = currentIndex === length ? 0 : currentIndex + 1;
  const prev = otherProduct?.[prevIndex];
  const next = otherProduct?.[nextIndex];

  const BASE_PATH = window.location.pathname.split('/')[1];

  return (
    <>
      {event && (
        <div style={{ backgroundColor: event.color || '#000000' }}>
          <T.Block>
            <T.Container>
              <T.Flex halign="space-between" py="40" gap={4}>
                <T.Col>
                  <>
                    <T.Block my="10">
                      <A.Image
                        className="hidden"
                        src={event.logo || ''}
                        height="40"
                        width="auto"
                      />
                    </T.Block>
                    <A.Text color="white" mb="10" fontSize="24" fw="bold">
                      {event.name}
                    </A.Text>
                    <A.Text color="white" mb="10" fontSize="18">
                      {event.subtitle}
                    </A.Text>
                    <div className={s.Header__line}></div>

                    <T.Block mt="15">
                      <A.Text color="white" fontSize="18">
                        <T.Flex className="flex" gap={1}>
                          <div>
                            <A.Icon icon="calendar2-week-fill" color="white" />
                          </div>
                          <div>
                            Du {event?.date} au {event?.date_of_the_end}
                          </div>
                          <div>
                            <A.Icon icon="geo-fill" color="white" />
                          </div>
                          <div>
                            {event.city}, {event.country}
                          </div>
                        </T.Flex>
                      </A.Text>
                    </T.Block>
                  </>
                </T.Col>
              </T.Flex>
            </T.Container>
          </T.Block>
        </div>
      )}
      <div className={styles.Product}>
        <BreadCrumb
          breadCrumb={[
            // {
            //   icon: null,
            //   href: '/' + BASE_PATH + '/preview/events',
            //   label: 'Events',
            //   isCurrent: false,
            // },
            {
              icon: null,
              href: undefined,
              label: event ? event.name : 'Event',
              isCurrent: true,
            },
            {
              icon: null,
              href: '/' + BASE_PATH + '/preview/events/' + slug + '/exhibitors',
              label: 'List Of Exhibitors',
              isCurrent: false,
            },
            {
              icon: null,
              href: '/' + BASE_PATH + '/preview/events/' + slug + '/products',
              label: 'List Of Products',
              isCurrent: false,
            },
            // {
            //   icon: null,
            //   href:
            //     '/' +
            //     BASE_PATH +
            //     '/preview/events/' +
            //     slug +
            //     '/exhibitors/' +
            //     product?.exhibitorId,
            //   label: exhibitor?.nom_societe || '',
            //   isCurrent: false,
            // },
            // {
            //   icon: null,
            //   href: undefined,
            //   label: product?.name || '',
            //   isCurrent: true,
            // },
          ]}
        />
        <div className={styles.Product__nav}>
          {length > 0 && (
            <Link
              to={`/${BASE_PATH}/preview/events/${slug}/products/${prev?.id}`}
              aria-label="Previous vine"
              className={styles.Product__nav__prev}
            ></Link>
          )}
          <h1 className={styles.Product__nav__title}>{product?.name}</h1>
          {length > 0 && (
            <Link
              to={`/${BASE_PATH}/preview/events/${slug}/products/${next?.id}`}
              aria-label="Next vine"
              className={styles.Product__nav__next}
            ></Link>
          )}
        </div>

        <div className={styles.Product__content}>
          <div className={styles.Product__photo}>
            {product?.photo && (
              <img
                src={product?.photo.url}
                alt=""
                width={product?.photo.width}
                height={product?.photo.height}
                className={styles.Product__photo__img}
              />
            )}
          </div>

          <div className={styles.Product__product}>
            <T.Flex halign="space-between" mb="25">
              <A.Text fw="normal">{product?.region}</A.Text>
              <A.Text>
                {product?.format} / {product?.alcool}%
              </A.Text>
            </T.Flex>
            <A.Text color="grey-50" mb="25">
              {product?.description_en}
            </A.Text>
            <A.Title
              as="h2"
              fontSize="22"
              fw="bold"
              bg="grey-05"
              p="20"
              mb="25"
            >
              Information
            </A.Title>

            {info.map(({ label, value }, i) => (
              <T.Flex halign="space-between" p="15" gap="1" key={label}>
                <A.Text fontSize="14" fw="normal">
                  {label}
                </A.Text>
                <A.Text fontSize="14" textAlign="end">
                  {value}
                </A.Text>
              </T.Flex>
            ))}
          </div>

          <div className={styles.Product__exhibitor}>
            <A.Title
              as="h2"
              fontSize="22"
              fw="bold"
              bg="grey-05"
              p="10"
              mb="25"
            >
              {exhibitor?.nom_societe}
              {!!(exhibitor?.hall && exhibitor?.stand) && (
                <a
                  href={`/floormap#${exhibitor?.hall}${exhibitor?.stand}`}
                  style={{ textDecoration: 'none' }}
                >
                  <A.Text fontSize="18" color="grey-50" fw="normal">
                    <img src={SvgPin} alt="" /> Hall{' '}
                    <A.Text as="span" color="black">
                      {exhibitor?.hall}
                    </A.Text>{' '}
                    Booth{' '}
                    <A.Text as="span" color="black">
                      {exhibitor?.hall}
                      {exhibitor?.stand}
                    </A.Text>
                  </A.Text>
                </a>
              )}
            </A.Title>
            <T.Block px="30">
              <a
                href={`/exhibitor/${exhibitor?.id}`}
                className={styles.Product__exhibitor__logo}
              >
                {exhibitor?.logo && (
                  <img
                    src={exhibitor?.logo.url}
                    alt=""
                    width={exhibitor?.logo.width}
                    height={exhibitor?.logo.height}
                    className={styles.Product__exhibitor__img}
                  />
                )}
              </a>
              <T.Block mb="20">
                {contact.map(({ icon, label }, i) => (
                  <T.Flex gap="2" p="15" key={i} valign="center">
                    <T.Block>{icon}</T.Block>
                    <A.Text fontSize="16" wordBreak="breakAll">
                      {label}
                    </A.Text>
                  </T.Flex>
                ))}
              </T.Block>
              <T.Flex gap="2" pl="20" mb="50">
                {exhibitor?.twitter && (
                  <a href={exhibitor?.twitter} target="_blank" rel="noreferrer">
                    <img src={SvgTwitter} alt="" />
                  </a>
                )}
                {exhibitor?.instagram && (
                  <a
                    href={exhibitor?.instagram}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={SvgInstagram} alt="" />
                  </a>
                )}
                {exhibitor?.linkedin && (
                  <a
                    href={exhibitor?.linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={SvgLinkedin} alt="" />
                  </a>
                )}
                {exhibitor?.facebook && (
                  <a
                    href={exhibitor?.facebook}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={SvgFacebook} alt="" />
                  </a>
                )}
              </T.Flex>
              {otherProduct && otherProduct?.length > 1 && (
                <>
                  <A.Title as="h3" fw={'normal'} mb="10">
                    Discover more products from this producer
                  </A.Title>

                  <Carousel
                    direction="horizontal"
                    prevButton={(attr) => (
                      <button
                        type="button"
                        aria-label="Previous"
                        className={styles.Product__item__button__prev}
                        {...attr}
                      />
                    )}
                    nextButton={(attr) => (
                      <button
                        type="button"
                        aria-label="Next"
                        className={styles.Product__item__button__next}
                        {...attr}
                      />
                    )}
                  >
                    <ul>
                      {otherProduct?.map(({ id, name, photo }) => (
                        <li key={id} className={styles.Product__item}>
                          {id === product?.id ? (
                            <div className={styles.Product__item__content}>
                              {photo && (
                                <img
                                  src={photo.url}
                                  alt=""
                                  width={photo.width}
                                  height={photo.height}
                                  className={styles.Product__item__content__img}
                                />
                              )}
                              <A.Text as="p" fontSize="14" fw="normal">
                                {name}
                              </A.Text>
                            </div>
                          ) : (
                            <a
                              href={`/${BASE_PATH}/preview/events/${slug}/products/${id}`}
                              className={styles.Product__item__content}
                              lang="en"
                            >
                              {photo && (
                                <img
                                  src={photo.url}
                                  alt=""
                                  width={photo.width}
                                  height={photo.height}
                                  className={styles.Product__item__content__img}
                                />
                              )}
                              <A.Text as="p" fontSize="14">
                                {name}
                              </A.Text>
                            </a>
                          )}
                        </li>
                      ))}
                    </ul>
                  </Carousel>
                </>
              )}
            </T.Block>
          </div>
        </div>
      </div>
    </>
  );
}
